
import React, { useCallback } from 'react';
import t from 'rcm-i18n'
import { CategoryData } from './types';

interface Props {
    category: CategoryData;
    onCategorySelect: (categoryId: number) => void;
}

const SidebarCategory = ({ category, onCategorySelect }: Props) => {
    const handleClick = useCallback(() => {
        onCategorySelect(category.id);
    }, [category]);

    return <li onClick={handleClick} className="all-products-sidebar-category">{t(category.name)}</li>
};

export default SidebarCategory;